exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.img-thumbnail{\n    width: auto !important;\n    height: 150px !important;\n}\n", ""]);

// exports
